import React from 'react'

function WorkingProcessFour() {
    return (
        <div>
            {/* working process start */}
            <div className="rts-working-process rts-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-area-style-six text-center">
                                <div className="pre-title">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/banner/shape/pre-title.png`}
                                        alt="pre-title"
                                    />
                                    <span className="pre">Work Process</span>
                                    <img
                                        className="two"
                                        src={`${process.env.PUBLIC_URL}/assets/images/banner/shape/pre-title.png`}
                                        alt="pre-title"
                                    />
                                </div>
                                <h2 className="title">Why Choose us?</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt--20">
                        <div className="col-xl-3 col-md-4">
                            {/* single-service area start */}
                            <div className="rts-single-service-style-process text-center">
                                <div className="icon">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/service/icon/22.svg`} alt="" />
                                </div>
                                <h5 className="title">Create an account</h5>
                                <p className="disc">
                                    Dictum stem tristique conubia arturie ornare vivamus euismod
                                </p>
                                <a href="#" className="rts-btn btn-primary-5 rounded-2">
                                    <i className="fal fa-arrow-right" />
                                </a>
                            </div>
                            {/* single-service area end */}
                        </div>
                        <div className="col-xl-3 col-md-4">
                            {/* single-service area start */}
                            <div className="rts-single-service-style-process text-center">
                                <div className="icon">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/service/icon/23.svg`} alt="" />
                                </div>
                                <h5 className="title">Consult with us</h5>
                                <p className="disc">
                                    Dictum stem tristique conubia arturie ornare vivamus euismod
                                </p>
                                <a href="#" className="rts-btn btn-primary-5 rounded-2">
                                    <i className="fal fa-arrow-right" />
                                </a>
                            </div>
                            {/* single-service area end */}
                        </div>
                        <div className="col-xl-3 col-md-4">
                            {/* single-service area start */}
                            <div className="rts-single-service-style-process text-center">
                                <div className="icon">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/service/icon/24.svg`} alt="" />
                                </div>
                                <h5 className="title">Fill up the form</h5>
                                <p className="disc">
                                    Dictum stem tristique conubia arturie ornare vivamus euismod
                                </p>
                                <a href="#" className="rts-btn btn-primary-5 rounded-2">
                                    <i className="fal fa-arrow-right" />
                                </a>
                            </div>
                            {/* single-service area end */}
                        </div>
                        <div className="col-xl-3 col-md-4">
                            {/* single-service area start */}
                            <div className="rts-single-service-style-process text-center">
                                <div className="icon">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/service/icon/22.svg`} alt="" />
                                </div>
                                <h5 className="title">Get Started!</h5>
                                <p className="disc">
                                    Dictum stem tristique conubia arturie ornare vivamus euismod
                                </p>
                                <a href="#" className="rts-btn btn-primary-5 rounded-2">
                                    <i className="fal fa-arrow-right" />
                                </a>
                            </div>
                            {/* single-service area end */}
                        </div>
                    </div>
                </div>
            </div>
            {/* working process end */}

        </div>
    )
}

export default WorkingProcessFour